import {
    Button,
    Card,
    CardContent,
    Grid,
    TextField,
    Typography,
    Divider,
    Modal,
    Box,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import { Margin } from "@mui/icons-material";
import nopdf from '../../../assets/images/nopdf.png'

const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "180vh",
    height: "85vh",
    bgcolor: "#f5f5f5",
    border: "1px solid #000",
    boxShadow: 24,
    p: 4,
    borderRadius: 10,
};



type Props = {};

const DocDetailAdd = (props: Props) => {
    const [TypeOption, setTypeOption] = useState<any>([{ value: "-1", label: "SelectFile" }]);



    useEffect(() => {
        getFileType();


    }, [])

    const getFileType = () => {
        const collectData = {
            fileTypeId: -1,
        };
        axios
            .post(HOST_URL.HOST_URL2 + `FileType/GetFileType`, collectData)
            .then((res) => {
                const arr = res.data.data.map((item: any) => ({
                    label: item.fileTypeName,
                    value: item.fileTypeId
                }));
                setTypeOption(arr);
            })

    };



    const [panOpens, setPanOpen] = React.useState(false);
    const [modalImg, setModalImg] = useState("");
    const handlePanClose = () => {
        setPanOpen(false);
    };
    const modalOpenHandle = (event: any) => {
        setPanOpen(true);
        if (event === "fileDoc") {
            setModalImg(formik.values.fileDoc);
        }
    };
    const ConvertBase64 = (file: Blob) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const otherDocChangeHandler = async (event: any, params: any) => {
        if (event.target.files && event.target.files[0]) {
            const file = event.target.files[0];
            const fileNameParts = file.name.split('.');
            const fileExtension = fileNameParts[fileNameParts.length - 1];
            if (fileExtension.toLowerCase() === 'pdf') {
                const base64 = await ConvertBase64(file);
                formik.setFieldValue(params, base64);
                console.log(base64)
            } else {
                // Display an error message indicating that only PDF files are allowed
                alert("Only PDF files are allowed to be uploaded.");
                // Optionally, you can clear the file input field
                event.target.value = null;
            }
        }
    };







    let navigate = useNavigate();
    const { i18n, t } = useTranslation();

    const [toaster, setToaster] = useState(false);



    const validationSchema = Yup.object({

        fileName: Yup.string().test(
            'required',
            " File Name Required",
            function (value: any) {
                return value && value.trim() !== '';
            }
        ),
    });

    const formik = useFormik({
        initialValues: {
            fileID: -1,
            fileName: "",
            fileNo: "",
            fileDescription: "",

            synopsis: "",
            subSubject: "",

            location: "",
            keyword: "",
            date: "",
            status: "",
            fileDoc: "",



            periodFrom: 0,
            periodUpto: 0,




            fileType: 0,







        },
        validationSchema: validationSchema,

        onSubmit: async (values) => {

            console.log("Before submission formik values", values)

            // Handle form submission
            try {
                const response = await axios.post(
                    HOST_URL.HOST_URL2 + `FileDetail/AddUpdateFileDetails`,



                    values
                );
                if (response.data.isSuccess) {
                    toast.success(response.data.mesg);
                    navigate('/DocManagement/DocDetail');
                } else {
                    toast.error(response.data.mesg);
                }
            } catch (error) {
                console.error("Error:", error);
                toast.error("An error occurred. Please try again.");
            }
        },


    });

    const requiredFields = ['fileName'];

    const back = useNavigate();




    return (
        <div>
            <div
                style={{
                    padding: "-5px 5px",
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    border: ".5px solid #FF7722",
                    marginTop: "3vh"
                }}
            >
                <CardContent>
                    <Typography
                        variant="h5"
                        textAlign="center"
                        style={{ fontSize: "18px", fontWeight: 500 }}
                    >
                        Doc Details Add
                    </Typography>

                    <Grid item sm={4} xs={12}>
                        <Typography style={{ marginTop: "-75px" }}>
                            <Button
                                type="submit"
                                onClick={() => back(-1)}
                                variant="contained"
                                style={{
                                    marginBottom: 15,
                                    marginTop: "45px",
                                    backgroundColor: "blue",
                                    width: 20,
                                }}
                            >
                                <ArrowBackSharpIcon />
                            </Button>
                        </Typography>
                    </Grid>
                    <Divider />
                    <br />
                    <form onSubmit={formik.handleSubmit}>
                        {toaster === false ? "" : <ToastApp />}
                        <Grid item xs={12} container spacing={2}>
                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="fileName"
                                    name="fileName"
                                    label={
                                        <span>
                                            Enter File Name{requiredFields.includes('fileName') && (
                                                <span style={{ color: formik.values.fileName ? 'green' : 'red' }}>*</span>
                                            )}
                                        </span>
                                    }
                                    value={formik.values.fileName}
                                    placeholder="Enter File Name"
                                    size="small"
                                    fullWidth
                                    style={{
                                        backgroundColor: 'white',
                                        borderColor: formik.touched.fileName && formik.errors.fileName ? 'red' : 'initial',
                                    }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.fileName && formik.errors.fileName ? (
                                    <div style={{ color: "red", margin: "5px" }}>{formik.errors.fileName}</div>
                                ) : null}
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="synopsis"
                                    name="synopsis"
                                    label="Synopsis"
                                    value={formik.values.synopsis}
                                    placeholder="Synopsis"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="fileNo"
                                    name="fileNo"
                                    label="file No"
                                    value={formik.values.fileNo}
                                    placeholder="file No"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="periodFrom"
                                    name="periodFrom"
                                    label="Period From"
                                    value={formik.values.periodFrom}
                                    placeholder="From Page"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="periodUpto"
                                    name="periodUpto"
                                    label="Period Upto"
                                    value={formik.values.periodUpto}
                                    placeholder="toPage"
                                    size="small"
                                    type="number"
                                    inputProps={{ maxLength: 10 }}
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={(e) => {
                                        console.log("chcek", e.target.value)
                                        formik.setFieldValue("periodUpto", e.target.value)
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="status-label">Enter Status</InputLabel>
                                    <Select
                                        id="status"
                                        name="status"
                                        value={formik.values.status}
                                        labelId="status-label"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                    >
                                        <MenuItem value="NA">NA</MenuItem>
                                        <MenuItem value="Issue">Issue</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="subSubject"
                                    name="subSubject"
                                    label="Sub Subject"
                                    value={formik.values.subSubject}
                                    placeholder="Sub Subject"
                                    size="small"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>


                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id=" fileDescription"
                                    name=" fileDescription"
                                    label="Enter  File Description"
                                    value={formik.values.fileDescription}
                                    placeholder="Enter  File Description"
                                    inputProps={{}}
                                    size="small"
                                    type="text"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>


                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="location"
                                    name="location"
                                    label="Enter Location"
                                    value={formik.values.location}
                                    placeholder="Enter Location"
                                    inputProps={{}}
                                    size="small"
                                    type="text"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="keyword"
                                    name="keyword"
                                    label="Enter Keyword"
                                    value={formik.values.keyword}
                                    placeholder="Enter Keyword"
                                    inputProps={{}}
                                    size="small"
                                    type="text"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>

                            <Grid item lg={4} xs={12}>
                                <TextField
                                    id="date"
                                    name="date"
                                    label="Enter Date"
                                    value={formik.values.date}
                                    placeholder="Enter Date"
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    type="date"
                                    fullWidth
                                    style={{ backgroundColor: "white" }}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>



                            <Grid item lg={4} xs={12}>
                                <Autocomplete
                                    disablePortal
                                    id="combo-box-demo"
                                    options={TypeOption}
                                    // value={
                                    //     ZoneOption.find(
                                    //         (option) => option.value === formik.values.fileTypeId
                                    //     ) || null
                                    // }
                                    fullWidth
                                    size="small"
                                    onChange={(event, newValue: any) => {
                                        console.log(newValue?.value);

                                        formik.setFieldValue("fileType", newValue?.value);

                                        formik.setFieldTouched("fileType", true);
                                        formik.setFieldTouched("fileType", false);
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label={
                                            <span>
                                                {t("text.SelectFileType")} {""}
                                                {requiredFields.includes('fileType') && (
                                                    <span style={{ color: formik.values.fileType ? 'green' : 'red' }}>*</span>
                                                )}
                                            </span>
                                        } />
                                    )}
                                />

                                {formik.touched.fileType && formik.errors.fileType ? (
                                    <div style={{ color: "red", margin: "5px" }}>
                                        {formik.errors.fileType}
                                    </div>
                                ) : null}
                            </Grid>

                            <Grid item lg={12} xs={12}>
                                <FormControl>

                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        defaultValue="Upload Small Files"
                                    >
                                        <FormControlLabel value="Upload Small Files" control={<Radio />} label="Upload Small Files" />
                                        <FormControlLabel value="Upload Large Files" control={<Radio />} label="Upload Large Files" />
                                        <FormControlLabel value="Attach Existing File" control={<Radio />} label="Attach Existing File" />
                                        <FormControlLabel value="Attach word Doc" control={<Radio />} label="Attach word Doc" />



                                    </RadioGroup>
                                </FormControl>

                            </Grid>


                            <Grid container spacing={1} item>
                                <Grid
                                    xs={12}
                                    md={4}
                                    sm={4}
                                    item
                                    style={{ marginBottom: "30px", marginTop: "30px" }}
                                >
                                    <TextField
                                        type="file"
                                        inputProps={{ accept: "application/pdf" }}
                                        InputLabelProps={{ shrink: true }}
                                        label={
                                            <strong style={{ color: "#000" }}>
                                                {t("text.EnterDocUpload")}
                                            </strong>
                                        }
                                        size="small"
                                        fullWidth
                                        style={{ backgroundColor: "white" }}
                                        onChange={(e) => otherDocChangeHandler(e, "fileDoc")}
                                    />
                                </Grid>
                                <Grid xs={12} md={4} sm={4} item></Grid>

                                <Grid xs={12} md={4} sm={4} item>
                                    <Grid
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-around",
                                            alignItems: "center",
                                            margin: "10px",
                                        }}
                                    >
                                        {formik.values.fileDoc == "" ? (
                                            <img
                                                src={nopdf}
                                                style={{
                                                    width: 150,
                                                    height: 100,
                                                    border: "1px solid grey",
                                                    borderRadius: 10,
                                                }}
                                            />
                                        ) : (
                                            <embed
                                                src={formik.values.fileDoc}
                                                style={{
                                                    width: 150,
                                                    height: 100,
                                                    border: "1px solid grey",
                                                    borderRadius: 10,
                                                    padding: "2px",
                                                }}
                                            />
                                        )}
                                        <Typography
                                            onClick={() => modalOpenHandle("fileDoc")}
                                            style={{
                                                textDecorationColor: "blue",
                                                textDecorationLine: "underline",
                                                color: "blue",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {t("text.Preview")}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Modal open={panOpens} onClose={handlePanClose}>
                                    <Box sx={style}>
                                        {modalImg == "" ? (
                                            <img
                                                src={nopdf}
                                                style={{
                                                    width: "170vh",
                                                    height: "75vh",
                                                }}
                                            />
                                        ) : (
                                            <embed
                                                // alt="preview image"
                                                src={modalImg}
                                                style={{
                                                    width: "170vh",
                                                    height: "75vh",
                                                    borderRadius: 10,
                                                }}
                                            />
                                        )}
                                    </Box>
                                </Modal>
                            </Grid>








                            <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="submit"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#059669",
                                            color: "white",
                                            marginTop: "10px",
                                        }}

                                    >
                                        {t("text.save")}
                                    </Button>
                                </Grid>

                                <Grid xs={6} style={{ margin: '6px' }}>
                                    <Button
                                        type="reset"
                                        fullWidth
                                        style={{
                                            backgroundColor: "#F43F5E",
                                            color: "white",
                                            marginTop: "10px",
                                        }}
                                        onClick={(e) => formik.resetForm()}
                                    >
                                        {t("text.reset")}
                                    </Button>
                                </Grid>

                            </Grid>
                        </Grid>
                    </form>

                </CardContent>
            </div>
        </div>
    );
};

export default DocDetailAdd;